export default "__VITE_ASSET__CH$A6weB__"